import configureStore from './configureStore'

import * as sel from './cleanSelectors'
export { default as rootReducer, allActions } from './reducers'

export const selectors = sel

export default configureStore
